import ListingHeader from "app/pages/Listing/ListingHeader/ListingHeader";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { bindActionCreators } from "redux";
import { getListingHeaderMerchandisings } from "app/pages/Merchandising/merchandisingSelector";
import { getOngoingProducts } from "app/pages/Listing/productsSelector";
import find from "lodash/find";
import { checkIfNavlogEnabled } from "app/pages/Listing/NavLogs/navLogsSelector";
import {
	shouldShowPaymentBanner,
	getPartnerListingHero,
	getShowPfsMessage,
} from "app/reducers/partnerSelector";
import { useEffect, useMemo } from "react";
import { fetchSDPFilters } from "app/pages/SmartDP/smartDPActionCreators";
import propTypes from "prop-types";

const ListingHeaderContainer = props => {
	const stateProps = useSelector(state => mapStateToProps(state, props), shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);

	const { partnerListingHero = {} } = stateProps;
	const { fetchSDPFilters } = dispatchProps;

	const { displaySmartDPForm = false } = partnerListingHero;

	useEffect(() => {
		if (displaySmartDPForm) {
			fetchSDPFilters();
		}
	}, [displaySmartDPForm]);

	return <ListingHeader {...props} {...stateProps} {...dispatchProps} />;
};

ListingHeaderContainer.propTypes = {
	fetchSDPFilters: propTypes.func,
	partnerListingHero: propTypes.object,
};

const mapStateToProps = (state, props) => {
	const products = getOngoingProducts(state);
	const idSpotlight = props.idSpotlight;
	return {
		resolution: state.resolution,
		heroProduct: find(getOngoingProducts(state), product => {
			return product.uri && product.uri === idSpotlight;
		}),
		activeFilters: state.productsFilters,
		merchandisingHeader: getListingHeaderMerchandisings(state, idSpotlight).merchList,
		products,
		brand: state.brand.code,
		partnerCode: state.partner.code,
		isNavlogsEnabled: checkIfNavlogEnabled(state),
		marketingBanner: state.partner.marketingBanner,
		showPfsMessage: getShowPfsMessage(state),
		partnerListingHero: getPartnerListingHero(state),
		isPaymentDescriptionBlockExist: shouldShowPaymentBanner(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators(
		{
			fetchSDPFilters,
		},
		dispatch
	);
};

export default ListingHeaderContainer;
